import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-sun-rain': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M510.5 225.5c37.3 6.8 65.5 39.3 65.5 78.5 0 44.2-35.8 80-80 80h-256c-44.2 0-80-35.8-80-80 0-38.8 27.6-71 64.2-78.4 0-0.5-0.2-1.1-0.2-1.6 0-53 43-96 96-96 32.1 0 60.3 15.9 77.7 40 10.4-5 22-8 34.3-8 39.2 0 71.6 28.3 78.5 65.5zM124.1 259.9c3.1 3.1 6.6 5.6 10.2 8.3-3.9 11.4-6.2 23.4-6.2 35.9 0 2.5 0.5 4.8 0.7 7.2l-59.2 19.7c-10.2 3.3-19.9-6.3-16.5-16.5l25.1-75.3-71-35.5c-9.6-4.8-9.6-18.5 0-23.3l71-35.5-25.1-75.3c-3.4-10.2 6.2-19.9 16.4-16.5l75.3 25.1 35.5-71c4.8-9.6 18.5-9.6 23.3 0l35.5 71 75.3-25.1c10.2-3.4 19.9 6.2 16.5 16.4l-8.9 26.7c-0.7 0-1.3-0.2-2-0.2-25.6 0-49.2 7.8-69.2 20.7-37.6-29.4-92.1-27.2-126.7 7.4-37.4 37.5-37.4 98.4 0 135.8zM193.9 201.9c-18.2 8.3-33.5 21.3-44.8 37.2-12.9-11.7-21.1-28.4-21.1-47.1 0-35.3 28.7-64 64-64 12.4 0 24 3.7 33.8 9.9-16.1 17.6-27.6 39.5-31.9 64zM524.5 418.1c7.7 4.4 10.3 14.1 6 21.8l-36.6 64c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.4-10.4-14.1-6-21.8l36.6-64c4.4-7.8 14.2-10.3 21.8-6zM428.5 418.1c7.7 4.4 10.3 14.1 6 21.8l-36.6 64c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.4-10.4-14.1-6-21.8l36.6-64c4.4-7.8 14.2-10.3 21.8-6zM332.5 418.1c7.7 4.4 10.3 14.1 6 21.8l-36.6 64c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.4-10.4-14.1-6-21.8l36.6-64c4.4-7.8 14.2-10.3 21.8-6zM236.5 418.1c7.7 4.4 10.3 14.1 6 21.8l-36.6 64c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.4-10.4-14.1-6-21.8l36.6-64c4.4-7.8 14.2-10.3 21.8-6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-sun-rain.js
// module id = 1214
// module chunks = 0